import { RegisterOptions } from 'react-hook-form'

export const resetPasswordValidation: { [x: string]: RegisterOptions } = {
  password: {
    required: {
      value: true,
      message: 'This field is required'
    },
    minLength: {
      value: 6,
      message: 'Must be at least 6 characters long'
    }
  },
  passwordConf: {
    required: {
      value: true,
      message: 'This field is required'
    }
  }
}